<script lang="ts" setup>
  import { FARE_TABLE_CLUB_LEVEL } from '@/components/fare-table/types'
  import type { TFareTableClubLevel } from '@/components/fare-table/types'
  import type { AssetStoryblok, ServiceSummaryStoryblok } from '@/storyblok/component-types-sb'

  type RowIndex = string | number
  const { isDesktop } = useBTBreakpoints()

  const props = withDefaults(
    defineProps<{
      services: any[]
      visibleFares: any[]
      clubLogo?: AssetStoryblok
      clubLevel?: TFareTableClubLevel
      findFareService: (fare: any, service: any) => any
      hasExpandedContent: (service: ServiceSummaryStoryblok) => boolean
      isRowExpanded: (service: ServiceSummaryStoryblok, index: RowIndex) => boolean
      toggleRowExpanded: (service: ServiceSummaryStoryblok, index: RowIndex) => void
    }>(),
    {
      services: () => [],
      visibleFares: () => [],
      clubLogo: undefined,
      clubLevel: FARE_TABLE_CLUB_LEVEL.none
    }
  )

  const contentKey = computed(() => {
    const fareKeys = props.visibleFares.map((fare: any) => fare?.key || fare?._uid || '').join('|')
    const serviceKeys = props.services.map((service: any) => service?._uid || service?.service || '').join('|')
    return `${fareKeys}::${serviceKeys}`
  })
</script>

<template>
  <FareTableMobileContent
    v-if="!isDesktop"
    :key="`mobile-${contentKey}`"
    :services="services"
    :visible-fares="visibleFares"
    :club-logo="clubLogo"
    :club-level="clubLevel"
    :find-fare-service="findFareService"
    :has-expanded-content="hasExpandedContent"
    :is-row-expanded="isRowExpanded"
    :toggle-row-expanded="toggleRowExpanded"
  />

  <FareTableDesktopContent
    v-else
    :key="`desktop-${contentKey}`"
    :services="services"
    :visible-fares="visibleFares"
    :club-logo="clubLogo"
    :club-level="clubLevel"
    :find-fare-service="findFareService"
    :has-expanded-content="hasExpandedContent"
    :is-row-expanded="isRowExpanded"
    :toggle-row-expanded="toggleRowExpanded"
  />
</template>
